/**
 * Class to manage logos of post sources, e.g. CNN, AdAge, Engadget etc.
 */
export class SourceLogo {
	/**
	 * Add a source_logo property to the post with the URL to the source logo image
	 * @param {Array} logos  The list of logos from `GET /feeds/logos`
	 * @param {Array} posts  A list of posts from `GET /posts` or the like
	 * @param [type="white"]  Either "white" or "black" depending on which logo color
	 */
	static splice(logos, posts, type = 'white') {
		if (!Array.isArray(logos) || !Array.isArray(posts)) {
			return;
		}
		posts.forEach(post => {
			post.source_logo = false; // Default to false
			// If the post has a domain name try to match it with the correct source logo
			if (logos) {
				logos.forEach(logo => {
					if (post.domain_name && post.domain_name.toLowerCase() === logo.domain.toLowerCase()) {
						post.source_logo = logo[type];
					}
				});
			}
		});
	}
}
